// extracted by mini-css-extract-plugin
export default {"secondLeftDiv":"leftoption_secondLeftDiv__PjXft","optiondiv":"leftoption_optiondiv__ZdnLe","optiondiv1":"leftoption_optiondiv1__D97Oz"};